import React from "react";
import Modal from "react-bootstrap/Modal";
import { useSalesReturnContext } from "../../context/SalesReturnContext";

const InformationModal = () => {
    const {
        modalPopup, 
        setModalPopup,
        handleConfirmModal,
        setBtndisable,
        btndisable,
        discModalPopup,
        setDiscModalPopup,
        freeInvModalPopup,
        basketAvlPopup,
        setBasketAvlPopup,
        freeInvNo,
        setFreeInvModalPopup,
        newSaveSalesReturn,
        pendingSubmitData
    } = useSalesReturnContext();

    

    return (
        <div>
            <>
                <div className="col-12 pt-0 pb-4">
                    <Modal show={basketAvlPopup}  aria-labelledby="contained-modal-title-vcenter" centered>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="col-md-12 col-lg-12 col-sm-12 py-3">
                                <div className="text-center">
                                    <p className="mb-0">
                The selected invoice contains basket or free invoice.
                                        <br />
                Partial return requests are not applicable to this invoice.
                                    </p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="float-end">
                                <button type="button" className="btn btn-primary me-3"  onClick={()=>setBasketAvlPopup(false)} >Ok</button>
                                
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className="col-12 pt-0 pb-4">
                    <Modal show={freeInvModalPopup} aria-labelledby="contained-modal-title-vcenter" centered>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="col-md-12 col-lg-12 col-sm-12 py-3">
                                <div className="text-center">
                                    <p className="mb-0">
                                        The Free Invoice {freeInvNo} is linked to this invoice. Returning this invoice will also return the linked free invoice.
                                        <br></br>
                                       Do you want to continue?
                                    </p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="float-end">
                                <button type="button" className="btn btn-primary me-3" onClick={()=>{setFreeInvModalPopup(false);setBtndisable(false);  newSaveSalesReturn(pendingSubmitData); }}>Yes</button>
                                <button type="button" className="btn btn-cancel-red" onClick={()=>{setFreeInvModalPopup(false);setBtndisable(false);}
                                }>No</button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>

                <div className="col-12 pt-0 pb-4">
                    <Modal show={modalPopup} aria-labelledby="contained-modal-title-vcenter" centered>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="col-md-12 col-lg-12 col-sm-12 py-3">
                                <div className="text-center">
                                    <p className="mb-0">
                                        Partial/total document adjustment/receipt has been made against this invoice.
                                        <br></br>
                                        Do you want to return this invoice?
                                    </p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="float-end">
                                <button type="button" className="btn btn-primary me-3" onClick={()=>{setBtndisable(true);handleConfirmModal();}} disabled={btndisable}>Yes</button>
                                <button type="button" className="btn btn-cancel-red" onClick={()=>{setModalPopup(false);
                                    setBtndisable(false);
                                }}>No</button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className="col-12 pt-0 pb-4">
                    <Modal show={discModalPopup} aria-labelledby="contained-modal-title-vcenter" centered>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="col-md-12 col-lg-12 col-sm-12 py-3">
                                <div className="text-center">
                                    <p className="mb-0">
                                        Flat Discount is applied to this invoice.
                                        <br></br>
                                        Partial return is not allowed for this invoice.
                                    </p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="float-end">
                                <button type="button" className="btn btn-primary me-3" onClick={()=>setDiscModalPopup(false)}>Ok</button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
            </>
        </div>
    );
};

export default InformationModal;